import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchUser, updateProfile } from "../redux/slices/profileSlice";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import MainLayout from "./layoutpage/MainLayout";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../api/axios";

const ProfilePage = ({ handleLogout }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user: reduxUser } = useSelector((state) => state.profile);
  const [localUser, setLocalUser] = useState(() => {
    return JSON.parse(localStorage.getItem("user")) || null;
  });
  const user = reduxUser || localUser;
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({
    name: "",
    email: "",
    mobile_number: "",
    voter_id: "",
    role: "",
    status: "",
    profile_photo_path: "",
  });
  const [errors, setErrors] = useState({});
  const [previewImage, setPreviewImage] = useState(null);

  const googleUser = JSON.parse(localStorage.getItem("googleUser"));

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1140);
      setIsMobile(window.innerWidth < 769);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!reduxUser) dispatch(fetchUser());
  }, [dispatch, reduxUser]);

  useEffect(() => {
    if (reduxUser) setLocalUser(reduxUser);
  }, [reduxUser]);

  useEffect(() => {
    if (user) {
      setEditData({
        name: user.name || "",
        email: user.email || "",
        mobile_number: user.mobile_number || "",
        voter_id: user.voter_id || "",
        role: user.role || "",
        status: user.status || "",
        profile_photo_path: user.profile_photo_path || "",
      });

      setPreviewImage(
        user.profile_photo_path
          ? `${api.defaults.baseURL}/${user.profile_photo_path}`
          : googleUser?.picture || "assets/images/users/avatar-1.jpg"
      );
    } else {
      navigate("/");
    }
  }, [user, navigate]);

  const mobileRegex = /^01[3-9]\d{8}$/;
  const voterRegex = /^\d{10,17}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log("edited photo path", file);
    if (file) {
      setEditData({ ...editData, profile_photo_path: file });
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!editData.name.trim()) newErrors.name = "Name is must required!";
    if (!editData.email.trim()) newErrors.email = "Email is required!";
    else if (!/\S+@\S+\.\S+/.test(editData.email))
      newErrors.email = "Invalid email format!";
    if (!editData.mobile_number.trim())
      newErrors.mobile_number = "Mobile number is required!";
    else if (!mobileRegex.test(editData.mobile_number))
      newErrors.mobile_number = "Enter a valid mobile number!";
    if (!editData.voter_id.trim()) newErrors.voter_id = "Voter ID is required!";
    else if (!voterRegex.test(editData.voter_id))
      newErrors.voter_id = "Voter ID must be 10 to 17 digits long!";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = () => {
    if (!validate()) return;
    dispatch(updateProfile({ editData, userId: user.id }));
    setShowModal(false);
  };

  if (!user) return null;

  return (
    <>
      <div className="wrapper">
        <div className="container-fluid">
          <div className="container py-5">
            <div
              className="card border-0 shadow-lg p-4"
              style={{
                borderRadius: "20px",
                background: "linear-gradient(145deg, #ffffff, #f3f6ff)",
              }}
            >
              <div className="row align-items-center">
                {/*  Left Profile Photo Card */}
                <div className="col-md-4 text-center">
                  <div
                    className="p-4 shadow-sm"
                    style={{
                      borderRadius: "10px",
                      background: "#fff",
                    }}
                  >
                    <img
                      src={previewImage}
                      alt="User Avatar"
                      className="rounded-circle shadow"
                      width="180"
                      
                      style={{ border: "2px solid white" ,height:"180px"}}
                    />

                    <h4 className="mt-3 fw-bold ">{user.name}</h4>
                    {/* <small className="text-muted">{user.email}</small> */}
                    <div className="d-flex align-items-center w-100 justify-content-center">
                      {" "}
                      <button
                        className="btn btn-primary btn-sm mt-4 px-4 py-2 shadow-sm "
                        style={{ borderRadius: "30px" }}
                        onClick={() => setShowModal(true)}
                      >
                        Edit Profile
                      </button>
                    </div>
                  </div>
                </div>

                {/* 🟩 Right Information Side with Beautiful Card Sections */}
                <div className="col-md-8">
                  <div
                    className="p-4 mb-4 shadow-sm"
                    style={{ background: "#fff", borderRadius: "20px" }}
                  >
                    <h5 className="fw-bold mb-3">Personal Details</h5>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label text-muted">Name</label>
                        <input
                          className="form-control"
                          value={user.name}
                          readOnly
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label text-muted">Email</label>
                        <input
                          className="form-control"
                          value={user.email}
                          readOnly
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label text-muted">
                          Mobile Number
                        </label>
                        <input
                          className="form-control"
                          placeholder="please enter your Mobile Number"
                          value={user.mobile_number || ""}
                          readOnly
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label text-muted">
                          NID / Voter ID
                        </label>
                        <input
                          className="form-control"
                          value={user.voter_id}
                          placeholder="please enter your NID"
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className="p-4 shadow-sm"
                    style={{ background: "#fff", borderRadius: "20px" }}
                  >
                    <h5 className="fw-bold mb-3">Account Information</h5>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label text-muted">Role</label>
                        <input
                          className="form-control"
                          value={user.role}
                          readOnly
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label text-muted">Status</label>
                        <input
                          className="form-control"
                          value={user.status}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*  Edit Modal Styled */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Update Profile</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="text-center mb-3">
              <img
                src={previewImage}
                width="110"
                height="110"
                className="rounded-circle shadow"
                alt="Preview"
              />

              <Form.Group controlId="formFile" className="mt-3">
                <Form.Control type="file" onChange={handleImageChange} />
              </Form.Group>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={editData.name}
                onChange={handleChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={editData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Mobile Number</Form.Label>
              <Form.Control
                type="text"
                name="mobile_number"
                value={editData.mobile_number}
                onChange={handleChange}
                placeholder="please enter your Mobile Number"
                isInvalid={!!errors.mobile_number}
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobile_number}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">NID / Voter ID</Form.Label>
              <Form.Control
                type="text"
                name="voter_id"
                value={editData.voter_id}

                placeholder="please enter your NID"
                onChange={handleChange}
                isInvalid={!!errors.voter_id}
              />
              <Form.Control.Feedback type="invalid">
                {errors.voter_id}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleUpdate}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfilePage;
